import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import img from "./../../assets/sheoran.jpg";
import dummy from "./../../assets/dummy.png";
import img2 from "./../../assets/Sunil.jpg";
import img3 from "./../../assets/Chhawari.jpg";
import img4 from "./../../assets/Sujata.jpg";
import img5 from "./../../assets/Sudhir.jpg";
import img6 from "./../../assets/Sharma.jpg";
import img7 from "./../../assets/Kundu.jpg";
import img8 from "./../../assets/Dhaka.jpg";
import img9 from "./../../assets/Suhag.jpg";
import img10 from "./../../assets/Dalal.jpg";
import img11 from "./../../assets/Sanjay.jpg";
import img12 from "./../../assets/Satish.jpg";
import img13 from "./../../assets/Nasiar.jpeg";



import { Table, Container, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faTimes, faUserTie } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
const data = [
  { district: '  Ambala',  profile: 'dswAmbala', officer: 'Col Ajay Kumar Sheoran (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Sainik Rest House, Ambala Cantt.", email:"Zsbambala3@gmail.com, amb.ainikb-hry@gov.in ",phone:"8875418547", image:img },

  { district: '  Bhiwani',  profile: 'dswBhiwani', officer: 'Wg Cdr Sunil Kumar (Retd)' ,address:"District Sainik and Ardh Sainik Welfare Office, Rly Road, Bhiwani.", email:"zsbbwn@gmail.com",phone:"8958181434", image:img2},

  { district: '  Charkhi Dadri',  profile: 'dswCharkhiDadri', officer: 'Wg Cdr Sunil Kumar (Retd)',address:"Sainik and Ardh Sainik Welfare Office, Sainik Rest House, Charkhi Dadri.", email:"zsbdadri@gmail.com",phone:"8958181434", image:img2 },

  { district: '  Faridabad',  profile: 'dswFaridabad', officer: 'Capt (IN) Rajneesh S Chhawari (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Sector-16, Faridabad", email:"zsbfaridabad@gmail.com",phone:"9425393650", image:img3 },


  { district: 'Fatehabad',  profile: 'dswFatehabad', officer: 'Wg Cdr Sujata (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, 24-A, Industrial Area, Fatehabad.", email:"fatehabadzsb@gmail.com",phone:"8155957960", image:img4 },

  { district: 'Gurugram',  profile: 'dswGurugram', officer: 'Col Davinder Singh Dhaka (Retd)' ,address:"District Sainik and Ardh Sainik Welfare Office, Opp. Apna Bazar, Civil Lines, Gurgaon.", email:"zsbggn@gmail.com",phone:"9953761992", image:img8},

  { district: 'Hisar',  profile: 'dswHisar', officer: 'Wg Cdr Sujata (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Near Old Court, Hisar.", email:"zsb.hisar@rediffmail.com",phone:"8155957960 ", image:img4 },

  { district: '  Jhajjar',  profile: 'dswJhajjar', officer: 'Col Rajeev Kundu (Retd)' ,address:"District Sainik and Ardh Sainik Welfare Office c/o Sainik Rest House, Jhajjar, Near Govt. Civil Hospital, Jhajjar, Haryana-124103.", email:"Secy.zsbjjr@yahoo.com, zsbjjr@gmail.com",phone:"8826674899", image:img7},

  { district: '  Jind',  profile: 'dswJind', officer: 'Wg Cdr Gaurika Suhag (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Sainik Rest House, Jind", email:"zsbjind@yahoo.com",phone:"8168588014", image:img9},

  { district: '  Kaithal',  profile: 'dswKaithal', officer: 'Col. Ajay Kumar Sheoran (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, \Bldg No.761/13, Amargarh Gamri, Opp. Gali No.-3, Kaithal", email:"secretaryzsbktl@gmail.com",phone:"8875418547", image:img },

  { district: '  Karnal',  profile: 'dswKarnal', officer: 'Wg Cdr Sanjay Kumar Rai (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Near Distt. Session Court- Old GT Road, Karnal.", email:"secretaryzsbknl@gmail.com",phone:"8126442556", image:img11 },

  { district: '  Kurukshetra',  profile: 'dswKurukshetra', officer: 'Col. Ajay Kumar Sheoran (Retd) ',address:"District Sainik and Ardh Sainik Welfare Office, Sainik Rest House Complex, Kurukshetra.", email:"zsbkkr@gmail.com",phone:"8875418547", image:img },


  { district: '  Narnaul',  profile: 'dswNarnaul', officer: 'Wg Cdr Satish Yadav',address:"District Sainik and Ardh Sainik Welfare Office, Sainik Rest House, Near Bus Stand, Narnaul.", email:"zsb_nnl@yahoo.com",phone:"9654374712", image:img12 },

  { district: '  Nuh',  profile: 'dswNuh', officer: 'Col Davinder Singh Dhaka (Retd)' ,address:"Near Bijli Board, Nuh (122107) ", email:"zsbggn@gmail.com",phone:"9953761992", image:img8},

  { district: '  Palwal',  profile: 'dswPalwal', officer: 'Col Davinder Singh Dhaka (Retd)',address:"Old SDM Court Complex, NH-2, Palwal", email:"palwalzsb@gmail.com",phone:"9953761992", image:img8 },

  { district: '  Panchkula',  profile: 'dswPanchkula', officer: 'Wg Cdr Sanjay Kumar Rai (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, 227, B Block, Yojna Bhawan, Sec-04, Panchkula.", email:"zsbpkl@yahoo.com",phone:"8126442556 ", image:img11 },

  { district: '  Panipat',  profile: 'dswPanipat', officer: 'Col Rajeev Kundu (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Kothi No.118, Adarsh Nagar, Near Post Office, CSD Canteen, Panipat.", email:"pnpzsb@gmail.com",phone:"8826674899", image:img7 },

  { district: '  Rewari',  profile: 'dswRewari', officer: 'Capt (IN) Rajneesh S Chhawari (Retd)',address:"District sainik Ardh Sainik welfare office Rewari, Pin - 123401, Tel Office - 01274224341, Near Govt Girls School Rewari", email:"zsbrwr@gmail.com",phone:"9425393650", image:img3 },

  { district: '  Rohtak',  profile: 'dswRohtak', officer: 'Wg Cdr Gaurika Suhag (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Civil Road, Near Chhotu Ram Park, Rohtak.", email:"zsbrohtak@gmail.com",phone:"8168588014", image:img9 },

  { district: '  Sirsa',  profile: 'dswSirsa', officer: 'Gp Capt Sudhir Nasiar (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Barnala Road, Near Police Lines, Sirsa.", email:"zsbsrs@gmail.com",phone:"7030392957", image:img13 },

  { district: '  Sonipat',  profile: 'dswSonipat', officer: 'Capt (IN) Rajneesh S Chhawari (Retd)',address:"District Sainik and Ardh Sainik Welfare Office, Gohana Road, Near Police Lines, Sonipat.", email:"zsbspt@gmail.com",phone:"9425393650", image:img3 },

  { district: '  Yamuna Nagar',  profile: 'dswYamunaNagar', officer: 'Wg Cdr Sanjay Kumar Rai (Retd) ',address:"Sainik and Ardh Sainik Welfare Office, Near Panchayat Bhawan, Yamuna Nagar", email:"zsbynr@yahoo.com",phone:"8126442556", image:img11 },
];


const WhoWho = () => {

  const [modalShow, setModalShow] = useState(false);
        const [selectedDistrict, setSelectedDistrict] = useState(null);
      
        const handleShowModal = (memorial) => {
          setSelectedDistrict(memorial);
          setModalShow(true);
        };
      
        const handleCloseModal = () => {
          setModalShow(false);
          setSelectedDistrict(null);
        };
  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin:'2%',
        borderRadius:'10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faUserTie} className="me-2" />
            Who's Who
          </h3>
        </Container>
      </div>
      
      <Container className="py-5">
        <Row>
          {data.map((item, index) => (
            <Col lg={4} md={6} className="mb-4" key={index}>
              <div 
                className="officer-card h-100"
                onClick={() => handleShowModal(item)}
                style={{
                  cursor: 'pointer',
                  background: 'white',
                  borderRadius: '10px',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                  transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                  overflow: 'hidden',
                  border: '1px solid rgba(0,0,0,0.05)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-12px) scale(1.02)';
                  e.currentTarget.style.boxShadow = '0 20px 60px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.1)';
                }}
              >
                <div style={{
                  background: index % 3 === 0 ? 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)' : 
                              index % 3 === 1 ? 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)' :
                              'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                  padding: '25px',
                  position: 'relative'
                }}>
                  
                  <div className="d-flex align-items-center">
                    <img 
                      src={item.image} 
                      alt={item.officer}
                      style={{
                        width: '80px',
                        height: '80px',
                        borderRadius: '50%',
                        border: '4px solid rgba(255,255,255,0.3)',
                        objectFit: 'cover',
                        boxShadow: '0 8px 25px rgba(0,0,0,0.2)'
                      }}
                    />
                    <div className="ms-3 text-white">
                      <h5 className="mb-1 fw-bold" style={{fontSize: '1.2rem', textShadow: '0 2px 4px rgba(0,0,0,0.2)'}}>{item.district}</h5>
                      <small style={{opacity: 0.95, fontSize: '0.9rem'}}>District Office</small>
                    </div>
                  </div>
                </div>
                
                <div className="p-4">
                  <h6 className="fw-bold mb-3" style={{color: '#1e3c72', fontSize: '1rem', lineHeight: '1.4'}}>
                    {item.officer}
                  </h6>
                  
                  <div className="mb-2" style={{fontSize: '0.9rem', color: '#6c757d'}}>
                    <FontAwesomeIcon icon={faPhone} className="me-2" style={{color: '#16a085'}} />
                    {item.phone}
                  </div>
                  
                  <div style={{fontSize: '0.9rem', color: '#6c757d'}}>
                    <FontAwesomeIcon icon={faEnvelope} className="me-2" style={{color: '#1e3c72'}} />
                    {item.email.length > 25 ? item.email.substring(0, 25) + '...' : item.email}
                  </div>
                  
                  <div className="mt-3 text-center">
                    <span style={{
                      background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                      color: 'white',
                      padding: '10px 24px',
                      borderRadius: '25px',
                      fontSize: '0.9rem',
                      fontWeight: '600',
                      display: 'inline-block',
                      boxShadow: '0 4px 15px rgba(102,126,234,0.3)'
                    }}>
                      View Details
                    </span>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        
        {selectedDistrict && (
          <Modal
            isOpen={modalShow}
            toggle={handleCloseModal}
            size="lg"
            centered
            style={{maxWidth: '700px'}}
          >
            <ModalHeader 
              toggle={handleCloseModal}
              style={{
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                color: 'white',
                border: 'none',
                padding: '20px'
              }}
            >
              <span className="fw-bold" style={{fontSize: '1.2rem'}}>
                <FontAwesomeIcon icon={faUserTie} className="me-2" />
                Officer Details
              </span>
            </ModalHeader>
            <ModalBody className="p-4">
              <Row>
                <Col md="4" className="text-center mb-3 mb-md-0">
                  <img 
                    src={selectedDistrict.image} 
                    alt={selectedDistrict.officer}
                    style={{
                      width: '150px',
                      height: '150px',
                      borderRadius: '50%',
                      border: '4px solid #1e3c72',
                      objectFit: 'cover',
                      boxShadow: '0 8px 25px rgba(102,126,234,0.3)'
                    }}
                  />
                  <div className="mt-3">
                    <h5 className="fw-bold mb-1" style={{color: '#1e3c72'}}>{selectedDistrict.district}</h5>
                    <small className="text-muted">District Office</small>
                  </div>
                </Col>
                <Col md="8">
                  <div className="ps-md-3">
                    <h4 className="fw-bold mb-3" style={{color: '#2c3e50'}}>
                      {selectedDistrict.officer}
                    </h4>
                    
                    <div className="mb-3 p-3" style={{background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%)', borderRadius: '12px', borderLeft: '4px solid #1e3c72'}}>
                      <small className="d-block mb-1" style={{color: '#1e3c72', fontWeight: '600'}}>Complete Address</small>
                      <p className="mb-0" style={{color: '#495057', fontSize: '0.95rem'}}>
                        {selectedDistrict.address}
                      </p>
                    </div>
                    
                    <div className="mb-3">
                      <small className="d-block mb-1" style={{color: '#1e3c72', fontWeight: '600'}}>
                        <FontAwesomeIcon icon={faEnvelope} className="me-2" style={{color: '#1e3c72'}} />
                        Email Address
                      </small>
                      <p className="mb-0 fw-semibold" style={{color: '#2c3e50'}}>
                        {selectedDistrict.email}
                      </p>
                    </div>
                    
                    <div>
                      <small className="d-block mb-1" style={{color: '#16a085', fontWeight: '600'}}>
                        <FontAwesomeIcon icon={faPhone} className="me-2" style={{color: '#16a085'}} />
                        Contact Number
                      </small>
                      <p className="mb-0 fw-semibold fs-5" style={{color: '#1e3c72'}}>
                        {selectedDistrict.phone}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter style={{borderTop: '1px solid #e9ecef', background: '#f8f9fa'}}>
              <Button 
                color="secondary" 
                onClick={handleCloseModal}
                style={{
                  background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '12px 30px',
                  fontWeight: '600',
                  boxShadow: '0 4px 15px rgba(102,126,234,0.3)'
                }}
              >
                <FontAwesomeIcon icon={faTimes} className="me-2" />Close
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </Container>
    </>
  );
};

export default WhoWho;
